import {WidgetState} from '../../types';

export const getReturnPlayersState = (state): WidgetState => {
    return state.get('returnPlayers').toJS();
};
